var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-metric",class:{ 'border-right': _vm.border }},[_c('div',{staticClass:"card-metric__value"},[_vm._v(_vm._s(_vm.value)+" "),(_vm.porcentaje)?_c('span',[_vm._v("%")]):_vm._e()]),_c('div',{staticClass:"card-metric__number"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }